import { render, staticRenderFns } from "./Wrong.vue?vue&type=template&id=eac023bc&scoped=true"
import script from "./Wrong.vue?vue&type=script&lang=js"
export * from "./Wrong.vue?vue&type=script&lang=js"
import style0 from "./Wrong.vue?vue&type=style&index=0&id=eac023bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eac023bc",
  null
  
)

export default component.exports